class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.message = this.dataset.message || 'Spend [amount] more for free shipping';
    this.success = this.dataset.success || 'You have unlocked free shipping';

    this.fill = this.querySelector('[data-shipping-bar-fill]');
    this.text = this.querySelector('[data-shipping-bar-text]');
    this.track = this.querySelector('[data-shipping-bar-track]');

    if (!this.threshold || !this.fill || !this.text) return;

    this.root = this.closest('cart-drawer') || document.body;

    this.observer = new MutationObserver(() => this.render());
    this.observer.observe(this.root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart-total-price'],
    });

    this.render();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  get total() {
    const el = this.root.querySelector('[data-cart-total-price]');
    if (!el) return null;
    return parseInt(el.dataset.cartTotalPrice, 10) || 0;
  }

  render() {
    const total = this.total;

    if (total === null) {
      this.classList.add('is-hidden');
      return;
    }
    this.classList.remove('is-hidden');

    const remaining = this.threshold - total;
    const progress = Math.min((total / this.threshold) * 100, 100);

    if (progress === this.lastProgress) return;
    this.lastProgress = progress;

    this.fill.style.width = `${progress}%`;
    this.track.setAttribute('aria-valuenow', Math.round(progress));
    this.classList.toggle('is-unlocked', remaining <= 0);

    this.text.innerHTML =
      remaining > 0
        ? this.escape(this.message).replace('[amount]', `<strong>${this.money(remaining)}</strong>`)
        : this.escape(this.success);
  }

  money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  escape(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}